import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { intlShape, injectIntl, FormattedMessage } from "react-intl";
import cx from "classnames";

class NumberFieldCmp extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    translatedLabel: PropTypes.string,
    type: PropTypes.string,
    customClass: PropTypes.string,
    disabled: PropTypes.bool,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
      warning: PropTypes.string
    }),
    intl: intlShape.isRequired,
    min: PropTypes.number
  };

  render() {
    const {
      input,
      label,
      translatedLabel,
      customClass,
      placeholder,
      disabled,
      meta: { touched, error, warning },
      intl,
      min
    } = this.props;

    const labelToUse =
      translatedLabel || label
        ? translatedLabel || intl.formatMessage({ id: label })
        : "";

    const placeholderToUse = placeholder
      ? intl.formatMessage({ id: placeholder })
      : labelToUse;

    return (
      <div
        className={cx(`NumberField`, customClass, {
          "NumberField--error": touched && error,
          "NumberField--warning": touched && warning
        })}
      >
        {labelToUse && <label>{labelToUse}</label>}
        <div>
          <input
            {...input}
            min={min}
            placeholder={placeholderToUse}
            type="number"
            disabled={disabled}
          />
          <span className={"NumberField__Error"}>
            {touched &&
              ((error && <FormattedMessage id={error} />) ||
                (warning && <FormattedMessage id={warning} />))}
          </span>
        </div>
      </div>
    );
  }
}

const NumberField = props => <Field component={NumberFieldCmp} {...props} />;

export default injectIntl(NumberField);



// WEBPACK FOOTER //
// ./src/modules/forms/fields/number-field.js